import React, { useState } from "react";
import "./faq.css";

const Faq = () => {
  const accordionData = [
    {
      question: "What does Golden Girls Health & Well-Being do?",
      answer:
        "We are an organization geared towards addressing issues in terms of physical, social and mental faced by women aged 50+ through advocacy campaigns, education, and support.",
    },
    {
      question: "Who can become a member?",
      answer:
        "Membership is open to any woman aged 50+ who is intrested in imporoving their overall health (both physcal and mental) while also supporting other women.",
    },
    {
      question: "How do I become a registered member?",
      answer:
        "Getting started is easy. Just click on Register fill in the details. You will receive an email once you registration is approved.",
    },
    {
      question: "Is there a membership fee?",
      answer:
        "At this moment registration is free. Post launch GG-M will charge an annual membership fee of Ksh. 3000 to its members. This will help organize events and run the association. The fee is to be paid by members registered as of June 30th.",
    },
  ];

  const [accordion, SetActiveAccordion] = useState(0);

  function toggleAccordion(index) {
    if (index === accordion) {
      SetActiveAccordion(-1);
      return;
    }
    SetActiveAccordion(index);
  }

  return (
    <section id="FAQ">
      <>
        <div className="faq__head">
          <span className="accordion__title">Frequently Asked Questions</span>
          <h1>Let's answer some of your questions.</h1>
        </div>
        <div className="faq__container">
          <div className="accordion__faq">
            {accordionData.map((item, index) => (
              <div
                className="accordion__simple"
                key={index}
                onClick={() => toggleAccordion(index)}
              >
                <div className="accordion__faq-heading">
                  <h3 className={accordion === index ? "active" : ""}>
                    {item.question}
                  </h3>
                  <div>
                    {accordion === index ? (
                      <>
                        <span className="verticle">-</span>
                      </>
                    ) : (
                      <>
                        <span className="verticle">+</span>
                      </>
                    )}
                  </div>
                </div>
                <div className="accordion__para">
                  <p className={accordion === index ? "active" : "inactive"}>
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    </section>
  );
};

export default Faq;
